export default "__VITE_ASSET__PIt785rR__"